import React from 'react';

const SvgTrustpilotStarWhite = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 46 46"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M39.534 19.711L13.23 38.801l3.838-11.798L7.021 19.71h12.42l3.837-11.798 3.837 11.798h12.419zm-16.255 11.8L30.462 30l2.862 8.8-10.045-7.29z"
}));

export default SvgTrustpilotStarWhite;